import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-bootstrap-toggle';
import masterField from '../../../../../components/search-form/master-field';


class SameAccountField extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.onToggleEnable = this.onToggleEnable.bind(this);
  }

  onToggleEnable() {
    this.props.onToggle();
  }

  render() {
    const { disabled, value } = this.props;

    return (
      <div>
        <Toggle
          onClick={this.onToggleEnable}
          on={<span>Allowed</span>}
          off={<span>Disallowed</span>}
          onstyle="success"
          size="xs"
          offstyle="danger"
          active={value}
          disabled={disabled}
        />
        &nbsp;&nbsp; submitting contact(s) that do not belong to the opportunity&rsquo;s account
      </div>
    );
  }
}

SameAccountField.propTypes = {
  value: PropTypes.bool,
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
  onToggle: PropTypes.func,
};
SameAccountField.defaultProps = {
  value: null,
  disabled: false,
  submitting: false,
  onToggle: () => {},
};
export default masterField(SameAccountField);
